import { render, staticRenderFns } from "./CategoryTypeAdd.vue?vue&type=template&id=8cfc31fa"
import script from "./CategoryTypeAdd.vue?vue&type=script&lang=js"
export * from "./CategoryTypeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports